module.exports = __webpack_public_path__ + "static/img/car.6729fa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/car.png
// module id = oEgv
// module chunks = 1